import { render, staticRenderFns } from "./RemovePreviouslyAddedProviderDialog.vue?vue&type=template&id=37e483c0&"
import script from "./RemovePreviouslyAddedProviderDialog.vue?vue&type=script&lang=js&"
export * from "./RemovePreviouslyAddedProviderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports